<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
              <label :class="{'txt-right' : true, 'required' : is_required}">Công ty</label>
              <DropdownScrollable cusClass="m-0 cs-width" :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
              <input class="input-group input_tmp_validator" id="company" />
            </div>
          </div>
          <div class="f-grid-col">
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2 accordion-item">
              <label @click="toggleIcon(1)" style="margin:0px;" class="accordion-label">
                <i style="width : 25px;" :class="show_1 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                <span>Thông tin chung</span>
              </label>
              <div class="accordion-content" v-show="show_1 == true">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Mã giấy phép</label>
                      <InputText disabled v-model="code" id="code_add" type="text" class="input-text-box cs-input" placeholder="<Hệ thống tạo tự động>"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Gói công việc SRA</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :disabled="mode=='edit'"
                        defaultLabel="name"
                        :limit="sra_obj.limit"
                        :loading="sra_obj.loading"
                        v-model="selsra"
                        :options="sra_obj.items"
                        :total="sra_obj.total"
                        @keyup="emitEventSra"
                        @offset="changeOffsetSra"
                        @scroll="emitEventSra"
                      />
                      <input class="input-group input_tmp_validator" id="sra_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Nhà thầu</label>
                      <InputText disabled v-model="contractor_name" id="contractor_name_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder=""/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Mô tả công việc</label>
                      <Textarea
                        id="description_add"
                        v-model="description"
                        :autoResize="true"
                        rows="3"
                        maxlength="14000"
                        class="input-text-box"
                        placeholder="Nhập tối đa 14000 ký tự"
                      />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Nhà máy</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        defaultLabel="name"
                        :limit="factory_obj.limit"
                        :loading="factory_obj.loading"
                        v-model="selfactory"
                        :options="factory_obj.items"
                        :total="factory_obj.total"
                        @keyup="emitEventFactory"
                        @offset="changeOffsetFactory"
                        @scroll="emitEventFactory"
                      />
                      <input class="input-group input_tmp_validator" id="factory_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Khu vực</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        defaultLabel="name"
                        :multiple="false"
                        :limit="areas_obj.limit"
                        :loading="areas_obj.loading"
                        v-model="selareas_sel"
                        :options="areas_obj.items"
                        :total="areas_obj.total"
                        @keyup="emitEventAreas"
                        @offset="changeOffsetAreas"
                        @scroll="emitEventAreas"
                      />
                      <input class="input-group input_tmp_validator" id="areas_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in selareas" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeSelareas(index)"></i>
                      </label>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Vị trí</label>
                      <Textarea
                        id="address_add"
                        v-model="address"
                        :autoResize="true"
                        rows="3"
                        maxlength="14000"
                        class="input-text-box"
                        placeholder="Nhập tối đa 14000 ký tự"
                      />
                    </div>
                  </div>
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Thời gian thực hiện từ - đến</label>
                      <div class="p-inputgroup">
                        <Calendar v-model="data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
                      </div>
                      <input class="input_tmp_validator_r" id="data_date_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Hiệu lực giấy phép từ - đến</label>
                      <div class="p-inputgroup">
                        <Calendar v-model="data_date_expiration" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
                      </div>
                      <input class="input_tmp_validator_r" id="data_date_expiration_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Giám sát</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :multiple="false"
                        :limit="supervisor_obj.limit"
                        :loading="supervisor_obj.loading"
                        v-model="supervisors_sel"
                        :options="supervisor_obj.items"
                        :total="supervisor_obj.total"
                        @keyup="emitEventSupervisor"
                        @scroll="emitEventSupervisor"
                        @offset="changeOffsetSupervisor"
                      />
                      <input class="input_tmp_validator_r" id="supervisors_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in supervisors" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeSupervisors(index)"></i>
                      </label>
                    </div>
                    
                    <div class="mt-2">
                      <label class="txt-right required">Duyệt cấp 1</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :limit="users1_obj.limit"
                        :loading="users1_obj.loading"
                        v-model="selusers1"
                        :options="users1_obj.items"
                        :total="users1_obj.total"
                        @keyup="emitEventUsers1"
                        @offset="changeOffsetUsers1"
                        @scroll="emitEventUsers1"
                      />
                      <input class="input_tmp_validator_r" id="selusers1_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Duyệt cấp 2</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :limit="users2_obj.limit"
                        :loading="users2_obj.loading"
                        v-model="selusers2"
                        :options="users2_obj.items"
                        :total="users2_obj.total"
                        @keyup="emitEventUsers2"
                        @offset="changeOffsetUsers2"
                        @scroll="emitEventUsers2"
                      />
                      <input class="input_tmp_validator_r" id="selusers2_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Người dùng công ty có liên quan nhận thông báo qua email</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        :multiple="false"
                        cusClass="m-0 cs-width"
                        :limit="users3_obj.limit"
                        :loading="users3_obj.loading"
                        v-model="selusers3_sel"
                        :options="users3_obj.items"
                        :total="users3_obj.total"
                        @keyup="emitEventUsers3"
                        @offset="changeOffsetUsers3"
                        @scroll="emitEventUsers3"
                      />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in selusers3" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeSelusers3(index)"></i>
                      </label>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Đối tượng nhận thông báo khác</label>
                      <InputText v-model="tag_text" @keydown.enter="handleEnter" placeholder="Nhập email nhận thông báo và nhấn Enter" />
                      <!-- <vue-tags-input
                        v-model="tag"
                        :tags="tags"
                        @tags-changed="handleTagsChanged"
                        class="cus-vue-tags-input"
                        placeholder=""
                      /> -->
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in tags_show" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeTagsShow(index)"></i>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2 accordion-item">
              <label @click="toggleIcon(2)" style="margin:0px;" class="accordion-label">
                <i style="width : 25px;" :class="show_2 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                <span>Mối nguy và biện pháp kiểm soát</span>
              </label>
              <div class="accordion-content" v-show="show_2 == true">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Những mối nguy liên quan</label>
                      <div class="row ml-0">
                        <div class="p-col-5 pl-0" style="padding:0px">
                          <DropdownScrollable 
                            placeholder="Danh mục mối nguy" 
                            :showClear="true" 
                            cusClass="m-0 cs-width"
                            :multiple="false"
                            :limit="category_obj.limit"
                            :loading="category_obj.loading"
                            v-model="category"
                            :options="category_obj.items"
                            :total="category_obj.total"
                            @keyup="emitEventCategory"
                            @scroll="emitEventCategory"
                            @offset="changeOffsetCategory"
                          />
                        </div>
                        <div class="p-col-7 pr-0" style="padding:0px 0px 0px 5px;">
                          <DropdownScrollable 
                            placeholder="Chọn mối nguy" 
                            :showClear="true" 
                            cusClass="m-0 cs-width"
                            :multiple="false"
                            :limit="danger_obj.limit"
                            :loading="danger_obj.loading"
                            v-model="danger"
                            :options="danger_obj.items"
                            :total="danger_obj.total"
                            @keyup="emitEventDanger"
                            @scroll="emitEventDanger"
                            @offset="changeOffsetDanger"
                          />
                        </div>
                      </div>
                      <input class="input_tmp_validator_r" id="danger_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in list_danger" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeDanger(index)"></i>
                      </label>
                    </div>
                  </div>
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Các biện pháp kiểm soát đề nghị</label>
                      <Textarea
                        id="control_measures_text"
                        v-model="control_measures_text"
                        :autoResize="true"
                        rows="3"
                        class="input-text-box"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable_v2.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
// import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components:{
    DropdownScrollable,
    // VueTagsInput,
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      code : '',
      show_1 : true,
      show_2 : true,
      filters: {},
      name: "",
      active: false,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      phone : null,
      is_required : true,
      factory_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selfactory : null,
      areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selareas : [],
      description : '',
      data_date : [],
      data_date_expiration : [],
      supervisor_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      supervisors : [],
      users1_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      users2_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers1 : null,
      selusers2 : null,
      list_danger : [
        // {id : "asda",name:"dangaga"},{id : "2323",name:"dangaga"}
      ],
      category_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      category : null,
      danger_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      danger : null,
      control_measures_text : '',
      edit_id : null,
      is_load : false,
      sra_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selsra : null,
      address : '',
      tag : '',
      tags :[],
      tags_show  : [],
      contractor_name : '',
      contractor : null,
      users3_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers3 : [],
      load_default : false,
      tag_text : '',
      selareas_sel : null,
      supervisors_sel : null,
      selusers3_sel : null,
    };
  },
  async mounted() {
    
    if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      if (this.mode == 'add') {
        this.load_default = true;
        this.company = {id: this.$store.getters.company_id};
        this.getListSra();
        await this.getListCompany();
        this.$commonFuction.sleep(1000);
        this.load_default = false;
      }
    }else{
      if (this.mode == 'add') {
        if (!this.$commonFuction.isEmpty(this.$route.query)){
          if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
            this.load_default = true;
            this.company = {id : this.$route.query.company_id};
            this.$commonFuction.sleep(1000);
            this.load_default = false;
          }
        }
        await this.getListCompany();
        // this.getListUsers1();
        // this.getListUsers2();
        // this.getListUsers3();
      }
    }
    console.log("this.company",this.company)
    if (this.mode == 'add') {
      if (!this.$commonFuction.isEmpty(this.$route.query)){
        if (!this.$commonFuction.isEmpty(this.$route.query.sra_id)){
          this.selsra = {id : this.$route.query.sra_id};
          this.getDetailSra()
        }
      }
    }
    // console.log("this.selsra",this.selsra)
    this.is_load = true
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      console.log("modelmodelmodelmodel==",this.model)
      this.company = this.model.company;
      this.code = this.model.code;
      this.description = this.model.description;
      this.selsra = this.model.sra;
      this.contractor_name = '['+this.model.contractor.code+'] '+this.model.contractor.name;
      this.selfactory = this.model.factory;
      this.address = this.model.address;
      if(this.model.sra_date_start && this.model.sra_date_end){
        this.data_date = [new Date(this.model.sra_date_start), new Date(this.model.sra_date_end)]
      }
      if(this.model.expiration_start && this.model.expiration_end){
        this.data_date_expiration = [new Date(this.model.expiration_start), new Date(this.model.expiration_end)]
      }
      if(this.model.atw_areas){
        this.selareas = this.model.atw_areas;
      }
      var supervisors = []
      if(this.model.atw_supervisor && this.model.atw_supervisor.length > 0){
        for (let i = 0; i < this.model.atw_supervisor.length; i++) {
          const e = this.model.atw_supervisor[i];
          supervisors.push({id : e.uid, fullname : e.fullname, name : e.fullname})
        }
      }
      this.supervisors = supervisors
      if(this.model.uid_c1){
        this.selusers1 = {
          id : this.model.uid_c1,
          fullname : this.model.fullname_c1,
          name : this.model.fullname_c1,
        }
      }
      if(this.model.uid_c2){
        this.selusers2 = {
          id : this.model.uid_c2,
          fullname : this.model.fullname_c2,
          name : this.model.fullname_c2,
        }
      }
      var selusers3 = []
      if(this.model.atw_users_related && this.model.atw_users_related.length > 0){
        for (let i = 0; i < this.model.atw_users_related.length; i++) {
          const e = this.model.atw_users_related[i];
          selusers3.push({id : e.uid, fullname : e.fullname, name : e.fullname})
        }
        this.selusers3 = selusers3
      }
      var tags_show = []
      if(this.model.emails){
        tags_show = this.model.emails.split('#')
        this.tags_show = tags_show
      }
      var list_danger = []
      if(this.model.atw_danger && this.model.atw_danger.length > 0){
        for (let i = 0; i < this.model.atw_danger.length; i++) {
          const ee = this.model.atw_danger[i];
          list_danger.push({id : ee.danger.id, name : ee.danger.name})
        }
      }
      this.control_measures_text = this.model.control_measures
      this.list_danger = list_danger;
      if (this.$route.params.id !== undefined) this.edit_id = this.$route.params.id;
      this.show_2 = true
      await this.getListFactory();
      await this.getListAreas();
      await this.getListUsers1();
      await this.getListUsers2();
      await this.getListUsers3();
      await this.getListCategory();
      this.$commonFuction.is_loading(false);
      await this.$commonFuction.sleep(1000);
      this.is_load = false
    }else{
      await this.$commonFuction.sleep(1000);
      this.is_load = false
    }
  },
  watch: {
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
      }
    },
    async "company"() {
      this.selareas_sel = null
      this.supervisors_sel = null
      this.selusers3_sel = null
      if(this.mode == 'add'){
        if(this.load_default==false){
          this.sra_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          }
          this.factory_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          }
          this.supervisor_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          }
          this.users1_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          },
          // this.users2_obj = {
          //   offset: 0,
          //   filters: {},
          //   limit: 20,
          //   items: [],
          //   total: 0,
          //   loading: false
          // },
          this.users3_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          },
          this.category_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          }
          this.selsra = null
          this.selfactory = null
          this.supervisors = []
          this.selusers1 = null
          // this.selusers2 = null
          this.selusers3 = []
          this.category = null
          this.danger = null
          this.list_danger = []
        }
        await this.getListSupervisor();
        await this.getListUsers1()
        // await this.getListUsers2()
        await this.getListUsers3()
        await this.getListCategory();
      }
      // await this.getListFactory();
      // await this.getListCategory();
      // await this.getListDanger();
    },
    async "selusers1"() {
      if(this.is_load==false){
        if(this.selusers1 && this.selusers1.id){
          this.selusers2 = null
          this.users2_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          }
          await this.getListUsers2()
        }else{
          this.selusers2 = null
          this.users2_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
          }
        }
      }
    },
    async "selsra"() {
      if(this.is_load==false){
        if(this.selsra && this.selsra.id){
          await this.getDetailSra()
        }
      }
    },
    async "selfactory"() {
      if(this.is_load==false){
        this.selareas = []
      }
      this.areas_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      await this.getListAreas();
    },
    async "category"() {
      // if(this.mode == 'add'){
      //   this.danger = null
      // }
      this.danger = null
      this.danger_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      await this.getListDanger();
    },
    async "danger"() {
      if(this.$commonFuction.isEmptyObject(this.danger)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.list_danger.length; i++) {
          if(this.list_danger[i].id == this.danger.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.list_danger.push(this.danger)
        }
        this.danger = null
      }
    },
    async "selareas_sel"() {
      if(this.$commonFuction.isEmptyObject(this.selareas_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.selareas.length; i++) {
          if(this.selareas[i].id == this.selareas_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.selareas.push(this.selareas_sel)
        }
        this.selareas_sel = null
      }
    },
    async "supervisors_sel"() {
      if(this.$commonFuction.isEmptyObject(this.supervisors_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.supervisors.length; i++) {
          if(this.supervisors[i].id == this.supervisors_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.supervisors.push(this.supervisors_sel)
        }
        this.supervisors_sel = null
      }
    },
    async "selusers3_sel"() {
      if(this.$commonFuction.isEmptyObject(this.selusers3_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.selusers3.length; i++) {
          if(this.selusers3[i].id == this.selusers3_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.selusers3.push(this.selusers3_sel)
        }
        this.selusers3_sel = null
      }
    },
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      let sra_add = document.getElementById("sra_add");
      if (this.$commonFuction.isEmptyObject(this.selsra) || this.$commonFuction.isEmpty(this.selsra)) {
        sra_add.setCustomValidity("Gói công việc SRA không được để trống!");
      } else {
        sra_add.setCustomValidity("");
      }
      let factory_add = document.getElementById("factory_add");
      if (
        this.$commonFuction.isEmptyObject(this.selfactory) ||
        this.$commonFuction.isEmpty(this.selfactory)
      ) {
        factory_add.setCustomValidity("Vui lòng chọn nhà máy!");
      } else {
        factory_add.setCustomValidity("");
      }
      let areas_add = document.getElementById("areas_add");
      if (
        this.$commonFuction.isEmptyObject(this.selareas) ||
        this.$commonFuction.isEmpty(this.selareas)
      ) {
        areas_add.setCustomValidity("Vui lòng chọn khu vực!");
      } else {
        areas_add.setCustomValidity("");
      }
      let description_add = document.getElementById("description_add");
      if ( this.$commonFuction.isEmpty(this.description)) {
        description_add.setCustomValidity("Vui lòng nhập mô tả công việc!");
      } else {
        description_add.setCustomValidity("");
      }
      let data_date_add = document.getElementById("data_date_add");
      if(this.data_date && this.data_date.length == 2){
        if(this.data_date[0] && this.data_date[1]){
          data_date_add.setCustomValidity("");
        }else{
          data_date_add.setCustomValidity("Vui lòng chọn thời gian thực hiện!");
        }
      }else{
        data_date_add.setCustomValidity("Vui lòng chọn thời gian thực hiện!");
      }

      let data_date_expiration_add = document.getElementById("data_date_expiration_add");
      if(this.data_date_expiration && this.data_date_expiration.length == 2){
        if(this.data_date_expiration[0] && this.data_date_expiration[1]){
          data_date_expiration_add.setCustomValidity("");
        }else{
          data_date_expiration_add.setCustomValidity("Vui lòng chọn thời gian thực hiện!");
        }
      }else{
        data_date_expiration_add.setCustomValidity("Vui lòng chọn thời gian thực hiện!");
      }

      let supervisors_add = document.getElementById("supervisors_add");
      if (
        this.$commonFuction.isEmptyObject(this.supervisors) ||
        this.$commonFuction.isEmpty(this.supervisors)
      ) {
        supervisors_add.setCustomValidity("Vui lòng chọn giám sát!");
      } else {
        supervisors_add.setCustomValidity("");
      }

      let selusers1_add = document.getElementById("selusers1_add");
      if (
        this.$commonFuction.isEmptyObject(this.selusers1) ||
        this.$commonFuction.isEmpty(this.selusers1)
      ) {
        selusers1_add.setCustomValidity("Vui lòng chọn người duyệt cấp 1!");
      } else {
        selusers1_add.setCustomValidity("");
      }
      let danger_add = document.getElementById("danger_add");
      if(this.list_danger.length > 0){
        danger_add.setCustomValidity("");
      }else{
        danger_add.setCustomValidity("Vui lòng chọn mối nguy liên quan!");
      }
      let control_measures_text = document.getElementById("control_measures_text");
      if ( this.$commonFuction.isEmpty(this.control_measures_text)) {
        control_measures_text.setCustomValidity("Vui lòng nhập biện pháp kiểm soát!");
      } else {
        control_measures_text.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async showcheck(){
      this.show_1 = true;
      this.show_2 = true;
      this.show_3 = true;
    },
    async saveData() {
      // this.$commonFuction.is_loading(true);
      await this.showcheck()
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var date_start = moment(this.data_date[0]).format("YYYY-MM-DD")
      var date_end = moment(this.data_date[1]).format("YYYY-MM-DD")
      var expiration_start = moment(this.data_date_expiration[0]).format("YYYY-MM-DD")
      var expiration_end = moment(this.data_date_expiration[1]).format("YYYY-MM-DD")
      
      var params = {
        name: this.name,
        sra: this.selsra,
        contractor: this.contractor,
        company: this.company,
        factory: this.selfactory,//nhà máy
        areas: this.selareas,//khu vực
        description : this.description,
        date_start : date_start,//ngày
        date_end : date_end,//ngày
        supervisors : this.supervisors,//giám sát
        users1 : this.selusers1,//duyệt 1
        users2 : this.selusers2,//duyệt 2
        users3 : this.selusers3,//liên quan
        tags_show : this.tags_show,
        list_danger : this.list_danger,
        control_measures_text : this.control_measures_text,
        expiration_start : expiration_start,
        expiration_end : expiration_end,
        address : this.address,
      };
      // console.log("saveData", params);
      this.$commonFuction.is_loading(false);
      this.$emit("save", params);
      
    },
    toggleIcon(key){
      if(key == 1){
        this.show_1 = !this.show_1
      }else if(key == 2){
        this.show_2 = !this.show_2
      }else if(key == 3){
        this.show_3 = !this.show_3
      }
    },
    emitEventFactory(keyword) {
      // console.log(keyword);
      this.$delete(this.factory_obj.filters, 'name');
      if (keyword) {
        this.factory_obj.filters.name = keyword;
      }
      this.getListFactory();
    },
    changeOffsetFactory(value) {
      this.factory_obj.offset = value;
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.factory_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.factory_obj.loading = true;
        await ApiRepository.post("/_api/factory/options", {filters: this.factory_obj.filters, limit: this.factory_obj.limit, offset: this.factory_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.factory_obj.offset > 0 ) {
            this.factory_obj.items.push(...res.data.data.factory);
          } else{
            this.factory_obj.items = res.data.data.factory;
          }
          this.factory_obj.total = res.data.data.count;
          this.factory_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.factory_obj.loading = false;
        })
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var factory_id = this.selfactory?.id ?? null;
      if(!factory_id){
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id ,factory_id : factory_id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    emitEventSupervisor(keyword) {
      // console.log(keyword);
      this.$delete(this.supervisor_obj.filters, 'name');
      if (keyword) {
        this.supervisor_obj.filters.name = keyword;
      }
      this.getListSupervisor();
    },
    changeOffsetSupervisor(value) {
      this.supervisor_obj.offset = value;
    },
    async getListSupervisor() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.supervisor_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.supervisor_obj.filters, limit: this.supervisor_obj.limit, offset: this.supervisor_obj.offset, company_id: this.company.id, type_company : 'internal'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.supervisor_obj.offset > 0 ) {
              this.supervisor_obj.items.push(...tmp);
            } else{
              this.supervisor_obj.items = tmp;
            }
            
            this.supervisor_obj.total = res.data.data.count;
            this.supervisor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.supervisor_obj.loading = false;
        })
      }
    },
    emitEventUsers1(keyword) {
      // console.log(keyword);
      this.$delete(this.users1_obj.filters, 'name');
      if (keyword) {
        this.users1_obj.filters.name = keyword;
      }
      this.getListUsers1();
    },
    changeOffsetUsers1(value) {
      this.users1_obj.offset = value;
    },
    async getListUsers1() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users1_obj.loading = true;
        // if(this.selusers2 && this.selusers2.id){
        //   console.log("sao ở đây lại có",this.selusers2)
        //   this.users1_obj.filters.not_ids = [this.selusers2.id]
        // }
        await ApiRepository.post("/_api/users/options", {filters: this.users1_obj.filters, limit: this.users1_obj.limit, offset: this.users1_obj.offset, company_id: this.company.id, type_company : 'internal'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users1_obj.offset > 0 ) {
              this.users1_obj.items.push(...tmp);
            } else{
              this.users1_obj.items = tmp;
            }
            
            this.users1_obj.total = res.data.data.count;
            this.users1_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users1_obj.loading = false;
        })
      }
    },
    emitEventUsers2(keyword) {
      // console.log(keyword);
      this.$delete(this.users2_obj.filters, 'name');
      if (keyword) {
        this.users2_obj.filters.name = keyword;
      }
      this.getListUsers2();
    },
    changeOffsetUsers2(value) {
      this.users2_obj.offset = value;
    },
    async getListUsers2() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(this.selusers1 && this.selusers1.id){
        this.users2_obj.filters.not_ids = [this.selusers1.id]
      }else{
        return
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users2_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.users2_obj.filters, limit: this.users2_obj.limit, offset: this.users2_obj.offset, company_id: this.company.id, type_company : 'internal'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users2_obj.offset > 0 ) {
              this.users2_obj.items.push(...tmp);
            } else{
              this.users2_obj.items = tmp;
            }
            
            this.users2_obj.total = res.data.data.count;
            this.users2_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users2_obj.loading = false;
        })
      }
    },
    async removeDanger(index){
      this.list_danger.splice(index, 1)
    },
    removeTagsShow(index){
      this.tags_show.splice(index, 1)
    },
    emitEventCategory(keyword) {
      // console.log(keyword);
      this.$delete(this.category_obj.filters, 'name');
      if (keyword) {
        this.category_obj.filters.name = keyword;
      }
      this.getListCategory();
    },
    changeOffsetCategory(value) {
      this.category_obj.offset = value;
    },
    async getListCategory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.category_obj.loading = true;
        await ApiRepository.post("/_api/category/options", {filters: this.category_obj.filters, limit: this.category_obj.limit, offset: this.category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.category_obj.offset > 0 ) {
              this.category_obj.items.push(...tmp);
            } else{
              this.category_obj.items = tmp;
            }
            this.category_obj.total = res.data.data.total;
            this.category_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.category_obj.loading = false;
        })
      }
    },
    emitEventDanger(keyword) {
      // console.log(keyword);
      this.$delete(this.danger_obj.filters, 'name');
      if (keyword) {
        this.danger_obj.filters.name = keyword;
      }
      this.getListDanger();
    },
    changeOffsetDanger(value) {
      this.danger_obj.offset = value;
    },
    async getListDanger() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(!this.$commonFuction.isEmptyObject(this.category)) {
        this.danger_obj.filters.category_id = this.category.id
      }
      this.danger_obj.filters.active = true
      this.danger_obj.filters.status = 'APPROVED'
      this.danger_obj.filters.get_other = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.danger_obj.loading = true;
        await ApiRepository.post("/_api/danger/options", {filters: this.danger_obj.filters, limit: this.danger_obj.limit, offset: this.danger_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.danger_obj.offset > 0 ) {
              this.danger_obj.items.push(...tmp);
            } else{
              this.danger_obj.items= tmp;
            }
            this.danger_obj.total = res.data.data.total;
            this.danger_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.danger_obj.loading = false;
        })
      }
    },
    emitEventSra(keyword) {
      // console.log(keyword);
      this.$delete(this.sra_obj.filters, 'name');
      if (keyword) {
        this.sra_obj.filters.name = keyword;
      }
      this.getListSra();
    },
    changeOffsetSra(value) {
      this.sra_obj.offset = value;
    },
    async getListSra() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.sra_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.sra_obj.loading = true;
        await ApiRepository.post("/_api/atw/sra_option", {filters: this.sra_obj.filters, company_id: this.company.id}, {headers}).then((res) => {
          if (this.sra_obj.offset > 0 ) {
            this.sra_obj.items.push(...res.data.data.sra);
          } else{
            this.sra_obj.items = res.data.data.sra;
          }
          this.sra_obj.total = res.data.data.count;
          this.sra_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.sra_obj.loading = false;
        })
      }
    },
    handleTagsChanged(newTags) {
      // console.log("newTags==",newTags[0].text)
      this.tags = [];
      if(newTags.length > 0 && newTags[0].text){
        if(this.isEmail(newTags[0].text)){
          if(!this.tags_show.includes(newTags[0].text)){
            this.tags_show.push(newTags[0].text)
          }
        }else{
          alert(`Email "`+newTags[0].text+`" không hợp lệ`);
        }
      }
      console.log("tags_show",this.tags_show)
    },
    handleEnter(){
      if(this.tag_text){
        if(this.isEmail(this.tag_text)){
          if(!this.tags_show.includes(this.tag_text)){
            this.tags_show.push(this.tag_text)
            this.tag_text = ''
          }else{
            alert(`Email "`+this.tag_text+`" đã tồn tại`);
          }
        }else{
          alert(`Email "`+this.tag_text+`" không hợp lệ`);
        }
      }
    },
    isEmail(email) {
      var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email);
    },
    emitEventUsers3(keyword) {
      // console.log(keyword);
      this.$delete(this.users3_obj.filters, 'name');
      if (keyword) {
        this.users3_obj.filters.name = keyword;
      }
      this.getListUsers3();
    },
    changeOffsetUsers3(value) {
      this.users3_obj.offset = value;
    },
    async getListUsers3() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users3_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.users3_obj.filters, limit: this.users3_obj.limit, offset: this.users2_obj.offset, company_id: this.company.id, type_company : 'internal'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users3_obj.offset > 0 ) {
              this.users3_obj.items.push(...tmp);
            } else{
              this.users3_obj.items = tmp;
            }
            
            this.users3_obj.total = res.data.data.count;
            this.users3_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users3_obj.loading = false;
        })
      }
    },
    async getDetailSra(){
      this.$commonFuction.is_loading(true);
      this.is_load = true
      var data_detail = null
      if(this.selsra && this.selsra.id){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = { "Authorization": "Bearer "+token };
          var {data} = await ApiRepository.post("/_api/atw/sra_detail", {sra_id: this.selsra.id , company_id : this.company.id}, {headers});
          if(data.status == 200){
            data_detail = data.data
          }
          this.$commonFuction.is_loading(false);
        }
      }
      // console.log("data_detail=====",data_detail)
      var data_date = []
      var contractor_name = ''
      var contractor = null
      var description = ''
      var address = ''
      var factory = null
      var areas = []
      var control_measures_text = ''
      var list_danger = []
      if(data_detail){
        data_date = [new Date(data_detail.date_start), new Date(data_detail.date_end)]
        contractor = data_detail.contractor
        contractor_name = '['+data_detail.contractor.code+'] '+data_detail.contractor.name
        description = data_detail.description
        address = data_detail.address
        factory = data_detail.factory
        areas = data_detail.sra_areas
        control_measures_text = data_detail.control_measures
        if(data_detail.sra_danger && data_detail.sra_danger.length > 0){
          for (let i = 0; i < data_detail.sra_danger.length; i++) {
            const ee = data_detail.sra_danger[i];
            list_danger.push({id : ee.danger.id, name : ee.danger.name})
          }
        }
        
      }
      this.selfactory = factory
      await this.$commonFuction.sleep(1000)
      this.selareas = areas
      this.data_date = data_date
      this.contractor_name = contractor_name
      this.contractor = contractor
      this.description = description
      this.address = address
      this.control_measures_text = control_measures_text
      this.list_danger = list_danger;
      await this.$commonFuction.sleep(1000)//chờ 2s vì watch nó chậm nên bị gán thành null
      this.$commonFuction.is_loading(false);
      this.is_load = false
    },
    async removeSelareas(index){
      this.selareas.splice(index, 1)
    },
    async removeSupervisors(index){
      this.supervisors.splice(index, 1)
    },
    async removeSelusers3(index){
      this.selusers3.splice(index, 1)
    },

  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
.drop-cus {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
}
.accordion-item {
  border: 1px solid #ddd;
  border-radius: 5px;
}
.accordion-label {
  display: block;
  padding: 8px;
  background-color: #DFE2E6;
  /* font-size: 15px; */
  font-weight: bold;
  cursor: pointer;
}
.accordion-content {
  margin-bottom: 10px;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.cs-icon-right {
  cursor: pointer;
}
.cs-text-right {
  color : #666666;
  float: right;
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
.vue-tags-input{
  width: 100%;
  max-width: 100% !important;
}
</style>
